"use strict";

/* mv images */
document.addEventListener('DOMContentLoaded', function () {
    var hero = document.querySelector('.mv__hero');
    var logo = document.querySelector('.mv__hero .mv__title');

    // column for PC
    var PC_CL = document.querySelectorAll('.mv__hero-pc .mv__column-left li');
    var PC_CR = document.querySelectorAll('.mv__hero-pc .mv__column-right li');
    var PC_CC = document.querySelector('.mv__hero-pc .mv__column-center');
    
    // column for SP
    var SP_CT = document.querySelectorAll('.mv__hero-sp .mv__column-top li');
    var SP_CB = document.querySelectorAll('.mv__hero-sp .mv__column-bottom li');
    var SP_CL = document.querySelectorAll('.mv__hero-sp .mv__column-left li');
    var SP_CR = document.querySelectorAll('.mv__hero-sp .mv__column-right li');
    var SP_CC = document.querySelector('.mv__hero-sp .mv__column-center');

    // order
    var OrderPC_L = [1, 9, 5, 12, 4, 8, 7, 11, 2, 3, 6, 10];
    var OrderPC_R = [4, 12, 8, 9, 5, 1, 6, 3, 10, 2, 11, 7];
    var OrderSP_T = [1, 13, 6, 9];
    var OrderSP_L = [7, 16, 4, 12];
    var OrderSP_R = [11, 3, 15, 8];
    var OrderSP_B = [5, 14, 2, 10];

    // run after image loads
    var imagesLoaded = function(callback) {
        var img = new Image();
        img.onload = callback;
        img.src = hero?.querySelector('img').src; 
    };

    imagesLoaded(function () {
        document.querySelector('.mv').classList.add('gradeBlue');

        // for PC
        PC_CL.forEach(function (item, i) {
            setTimeout(function () {
                item.classList.add('animation');
            }, OrderPC_L[i] * 100);
        });

        PC_CR.forEach(function (item, i) {
            setTimeout(function () {
                item.classList.add('animation');
            }, OrderPC_R[i] * 100);
        });

        setTimeout(function () {
            PC_CC.classList.add('animation');
        }, 1300);

        //for SP
        SP_CL.forEach(function (item, i) {
            setTimeout(function () {
                item.classList.add('animation');
            }, OrderSP_L[i] * 75);
        });

        SP_CR.forEach(function (item, i) {
            setTimeout(function () {
                item.classList.add('animation');
            }, OrderSP_R[i] * 75);
        });

        SP_CT.forEach(function (item, i) {
            setTimeout(function () {
                item.classList.add('animation');
            }, OrderSP_T[i] * 75);
        });

        SP_CB.forEach(function (item, i) {
            setTimeout(function () {
                item.classList.add('animation');
            }, OrderSP_B[i] * 75);
        });

        setTimeout(function () {
            SP_CC.classList.add('animation');
        }, 1300);

        // for logo
        setTimeout(function () {
            logo.classList.add('animation');
        }, 1600);

        // cange hero width to 100%
        setTimeout(function () {
            hero.style.width = '100%';
        }, 1620);
    });
});



/* swiper */
window.addEventListener('DOMContentLoaded', function () {
    if(!window.Shopify.designMode) {
        document.querySelectorAll('.js-archive-data').forEach((data) => {
            const elm = document.querySelector('.people__list')
            if (elm) {
                elm.innerHTML += data.innerHTML;
                document.querySelector(`#${data.dataset.id}`).remove();
            }
        });
    }

	var mySwiper_hero = new Swiper ('.slide-hero', {
		loop: true,
		effect: 'fade',
		centeredSlides: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false
		}
	});

  var mySwiper = new Swiper('.slide1', {
    loop: true,
    effect: 'fade',
    lazy: {
      loadPrevNext: true,
    },
    centeredSlides: true,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    }
  });
  
  setTimeout(function () {
    var mySwiper2 = new Swiper('.slide2', {
      loop: true,
      effect: 'fade',
            lazy: {
                loadPrevNext: true,
            },
      centeredSlides: true,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false
      }
    });
  }, 3500);

}, false);

